// removed by extract-text-webpack-plugin
module.exports = {"List":"_24BAi4CBrqW1uI9W-xWXL2","Header":"gWB-UHrd1I2pYiGF5QkEG","green":"uREdB21PaaWschM0aGjpU","red":"oc_R53qY769G-7q-p9z_C","Row":"_1h9k9BqNfs7LicuiciOtXQ"};


//////////////////
// WEBPACK FOOTER
// ./src/lists/LeavesList/index.css
// module id = 961
// module chunks = 0